import { render, staticRenderFns } from "./PaxForm.vue?vue&type=template&id=0de871c0&"
import script from "./PaxForm.vue?vue&type=script&lang=ts&"
export * from "./PaxForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports